export default __webpack_public_path__ + "static/media/home-restaurant-bg-03.3b62c5f9.jpg";